'use client';

import { CircleSlashIcon } from 'lucide-react';
import { ErrorBoundary } from 'react-error-boundary';
import { z } from 'zod';

import GenericFallback from '~/components/molecules/GenericFallback';
import PropertyTease from '~/components/organisms/properties/PropertyTease';
import { modelPropertyType } from '~/lib/api/models';

type PropertiesByType = z.infer<
  typeof modelPropertyType.schema
>['propertyType']['properties'];

type Props = {
  properties: PropertiesByType;
};

const PropertyList: React.FC<Props> = ({ properties }) => {
  const hasProperties = properties.edges.length > 0;

  return (
    <>
      {hasProperties ? (
        <>
          <ul className="relative mb-10 flex flex-col gap-20 max-lg:pt-10 lg:mb-0 lg:block">
            {properties.edges.map(({ node }) => {
              return (
                <li
                  key={node.id}
                  className="relative w-full [contain-intrinsic-size:calc(100svh-160px)] [content-visibility:auto]"
                >
                  <ErrorBoundary
                    fallback={
                      <GenericFallback variant="error" showIcon>
                        Error while rendering PropertyTease
                      </GenericFallback>
                    }
                  >
                    <PropertyTease {...node} />
                  </ErrorBoundary>
                </li>
              );
            })}
          </ul>
        </>
      ) : (
        <div className="text-brand-quinary flex flex-row items-center justify-center gap-2 px-4 py-40">
          <CircleSlashIcon size={16} />
          <span>Aucun bien à afficher</span>
        </div>
      )}
    </>
  );
};

export default PropertyList;
